import request from '@/utils/request';

// 新增授权
export function addAuth(data) {
  return request({
    url: '/user/auth',
    method: 'post',
    data
  });
}
